export const PATH_SEPARATOR = '.';
export const TARGET = Symbol('target');
export const UNSUBSCRIBE = Symbol('unsubscribe');
